const Bar = ({ w = "w-full", tone = "bg-white/10", h = "h-2" }) => (
  <div className={`${h} ${w} rounded-full ${tone}`} />
);

const TabBar = ({ active = 0, count = 4 }) => (
  <div className="mt-auto flex h-8 items-center justify-around rounded-full bg-white/5">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className={`h-1.5 w-1.5 rounded-full ${i === active ? "bg-accent" : "bg-white/20"}`} />
    ))}
  </div>
);

/* ---------- PULSE ---------- */

const PulseScreen = () => (
  <div className="flex h-full flex-col gap-2 p-3 pt-9">
    <div className="flex items-center justify-between">
      <div>
        <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">PULSE — TUE 28</div>
        <div className="mt-0.5 font-display text-[11px] font-semibold text-white">Good morning</div>
      </div>
      <div className="h-5 w-5 rounded-full bg-gradient-to-br from-accent to-blue-900 ring-1 ring-accent/60" />
    </div>

    <div className="flex items-center gap-2.5 rounded-xl bg-white/5 p-2.5 ring-1 ring-white/5">
      <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-4 border-accent shadow-[0_0_18px_rgba(59,130,246,0.45)]">
        <span className="font-display text-xs font-semibold text-white">84%</span>
      </div>
      <div className="flex-1 space-y-[6px]">
        <div className="font-mono text-[5px] tracking-widest text-zinc-500">TODAY'S RINGS</div>
        {[
          ["MOVE", "82%", "bg-accent"],
          ["EXERCISE", "64%", "bg-accent/60"],
          ["STAND", "91%", "bg-white/40"],
        ].map(([l, w, c]) => (
          <div key={l} className="flex items-center gap-1.5">
            <span className="w-9 font-mono text-[5px] tracking-wider text-zinc-500">{l}</span>
            <div className="h-1 flex-1 rounded-full bg-white/10">
              <div className={`h-full rounded-full ${c}`} style={{ width: w }} />
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="grid grid-cols-2 gap-2">
      <div className="rounded-lg bg-white/5 p-2 ring-1 ring-white/5">
        <div className="font-display text-[10px] font-semibold text-accent">6,482</div>
        <div className="font-mono text-[5px] tracking-widest text-zinc-500">STEPS</div>
      </div>
      <div className="rounded-lg bg-white/5 p-2 ring-1 ring-white/5">
        <div className="font-display text-[10px] font-semibold text-white">42m</div>
        <div className="font-mono text-[5px] tracking-widest text-zinc-500">ZONE 2</div>
      </div>
    </div>

    <div className="rounded-lg bg-white/5 p-2 ring-1 ring-white/5">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[5px] tracking-widest text-zinc-500">HEART RATE</span>
        <span className="font-display text-[10px] font-semibold text-accent">
          72 <span className="text-[6px] font-normal text-zinc-500">BPM</span>
        </span>
      </div>
      <svg className="mt-1 h-7 w-full" viewBox="0 0 100 20" preserveAspectRatio="none">
        <path
          d="M0 12 L 8 12 L 12 5 L 16 17 L 22 9 L 34 12 L 40 6 L 46 15 L 54 10 L 66 12 L 72 6 L 78 14 L 86 10 L 100 12"
          fill="none"
          stroke="#3b82f6"
          strokeWidth="1.2"
        />
      </svg>
    </div>

    <div className="flex items-center gap-2 rounded-lg bg-accent-soft p-2 ring-1 ring-accent/30">
      <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent shadow-[0_0_10px_rgba(59,130,246,0.5)]">
        <svg className="ml-[1px] h-2 w-2 text-white" viewBox="0 0 8 8" fill="currentColor">
          <path d="M1 0.5 L 7.5 4 L 1 7.5 Z" />
        </svg>
      </div>
      <div className="flex-1">
        <div className="font-display text-[9px] font-semibold text-white">Tempo Run</div>
        <div className="font-mono text-[5px] tracking-widest text-zinc-400">UP NEXT — 30 MIN</div>
      </div>
      <div className="font-mono text-[6px] text-accent">17:30</div>
    </div>

    <TabBar active={0} />
  </div>
);

const PulseTrendsScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">PULSE / TRENDS</div>
    <div className="mt-1 rounded-xl bg-white/5 p-2.5">
      <div className="font-mono text-[6px] tracking-widest text-zinc-500">WEEKLY LOAD</div>
      <div className="mt-2 flex h-16 items-end justify-between gap-1">
        {[40, 65, 30, 80, 55, 92, 70].map((h, i) => (
          <div
            key={i}
            className={`w-full rounded-sm ${i === 5 ? "bg-accent shadow-[0_0_10px_rgba(59,130,246,0.5)]" : "bg-white/15"}`}
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
      <div className="mt-1 flex justify-between font-mono text-[5px] text-zinc-600">
        {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
          <span key={i}>{d}</span>
        ))}
      </div>
    </div>
    <div className="grid grid-cols-2 gap-2">
      <div className="rounded-lg bg-white/5 p-2">
        <div className="font-display text-[10px] font-semibold text-accent">+12%</div>
        <div className="font-mono text-[5px] tracking-widest text-zinc-500">VOLUME</div>
      </div>
      <div className="rounded-lg bg-white/5 p-2">
        <div className="font-display text-[10px] font-semibold text-white">7.4h</div>
        <div className="font-mono text-[5px] tracking-widest text-zinc-500">AVG SLEEP</div>
      </div>
    </div>
    <div className="rounded-lg bg-white/5 p-2">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[5px] tracking-widest text-zinc-500">RECOVERY</span>
        <span className="font-mono text-[6px] text-accent">OPTIMAL</span>
      </div>
      <div className="mt-1.5 h-1 rounded-full bg-white/10">
        <div className="h-full w-4/5 rounded-full bg-accent" />
      </div>
    </div>
    <TabBar active={1} />
  </div>
);

const PulseWorkoutScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="flex items-center justify-between">
      <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">LIVE WORKOUT</div>
      <div className="h-1.5 w-1.5 animate-pulse rounded-full bg-accent" />
    </div>
    <div className="mt-2 flex flex-col items-center rounded-xl bg-white/5 py-4">
      <div className="font-mono text-[6px] tracking-widest text-zinc-500">ELAPSED</div>
      <div className="font-display text-2xl font-bold text-white">24:16</div>
      <div className="mt-1 font-mono text-[6px] text-accent">ZONE 3 — 142 BPM</div>
    </div>
    <div className="grid grid-cols-3 gap-1.5">
      {[["2.4", "KM"], ["5:32", "/KM"], ["310", "KCAL"]].map(([v, l]) => (
        <div key={l} className="rounded-lg bg-white/5 p-1.5 text-center">
          <div className="font-display text-[10px] font-semibold text-white">{v}</div>
          <div className="font-mono text-[5px] tracking-widest text-zinc-500">{l}</div>
        </div>
      ))}
    </div>
    <div className="rounded-lg bg-white/5 p-2">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[5px] tracking-widest text-zinc-500">HEART RATE</span>
        <span className="font-display text-[10px] font-semibold text-accent">142</span>
      </div>
      <svg className="mt-1 h-6 w-full" viewBox="0 0 100 20" preserveAspectRatio="none">
        <path d="M0 12 L 10 12 L 14 4 L 18 18 L 24 10 L 40 12 L 46 5 L 52 16 L 60 11 L 76 12 L 82 6 L 88 15 L 100 11" fill="none" stroke="#3b82f6" strokeWidth="1" />
      </svg>
    </div>
    <div className="mt-auto flex items-center justify-center">
      <div className="flex h-9 w-full items-center justify-center rounded-full bg-accent font-mono text-[7px] tracking-[0.25em] text-white shadow-[0_0_16px_rgba(59,130,246,0.5)]">
        PAUSE
      </div>
    </div>
  </div>
);

/* ---------- LEDGER ---------- */

const LedgerScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="flex items-center justify-between">
      <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">LEDGER</div>
      <div className="h-4 w-4 rounded-full bg-white/10 ring-1 ring-white/20" />
    </div>
    <div className="rounded-xl bg-accent-soft p-2.5 ring-1 ring-accent/30">
      <div className="font-mono text-[6px] tracking-widest text-zinc-400">TOTAL BALANCE</div>
      <div className="mt-1 font-display text-lg font-semibold text-white">$12,480</div>
      <div className="font-mono text-[6px] text-accent">+8.2% THIS MONTH</div>
    </div>
    {["w-3/4", "w-1/2", "w-2/3"].map((w, i) => (
      <div key={i} className="flex items-center gap-2 rounded-lg bg-white/5 p-2">
        <div className={`h-5 w-5 rounded-md ${i === 0 ? "bg-accent/40" : "bg-white/10"}`} />
        <div className="flex-1 space-y-1">
          <Bar w={w} h="h-1" />
          <Bar w="w-1/3" h="h-1" tone="bg-white/5" />
        </div>
        <div className="font-mono text-[6px] text-zinc-400">-$24</div>
      </div>
    ))}
    <div className="mt-auto self-end">
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-accent font-display text-sm font-semibold text-white shadow-[0_0_16px_rgba(59,130,246,0.5)]">+</div>
    </div>
  </div>
);

const LedgerBudgetsScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">LEDGER / BUDGETS</div>
    <div className="mt-1 rounded-xl bg-white/5 p-2.5">
      <div className="font-mono text-[6px] tracking-widest text-zinc-500">JULY</div>
      <div className="mt-1 font-display text-base font-semibold text-white">
        $1,240 <span className="text-[9px] font-normal text-zinc-500">/ $1,800</span>
      </div>
    </div>
    {[["GROCERIES", 72, true], ["TRANSPORT", 45, false], ["LEISURE", 88, true], ["HOME", 30, false]].map(([n, v, hot]) => (
      <div key={n} className="rounded-lg bg-white/5 p-2">
        <div className="flex justify-between font-mono text-[6px] tracking-widest text-zinc-400">
          <span>{n}</span>
          <span>{v}%</span>
        </div>
        <div className="mt-1.5 h-1 rounded-full bg-white/10">
          <div className={`h-full rounded-full ${hot ? "bg-accent" : "bg-white/30"}`} style={{ width: `${v}%` }} />
        </div>
      </div>
    ))}
    <TabBar active={1} count={3} />
  </div>
);

const LedgerStatsScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">LEDGER / INSIGHTS</div>
    <div className="mt-1 rounded-xl bg-white/5 p-2.5">
      <div className="font-mono text-[6px] tracking-widest text-zinc-500">SPENDING — 6M</div>
      <svg className="mt-2 h-16 w-full" viewBox="0 0 100 40" preserveAspectRatio="none">
        <path d="M0 32 C 15 28, 25 34, 40 22 S 70 12, 100 8 L 100 40 L 0 40 Z" fill="rgba(59,130,246,0.12)" />
        <path d="M0 32 C 15 28, 25 34, 40 22 S 70 12, 100 8" fill="none" stroke="#3b82f6" strokeWidth="1.5" />
      </svg>
      <div className="flex justify-between font-mono text-[5px] text-zinc-600">
        {["FEB", "MAR", "APR", "MAY", "JUN", "JUL"].map((m) => (
          <span key={m}>{m}</span>
        ))}
      </div>
    </div>
    {[["AVG / DAY", "$41"], ["TOP CATEGORY", "FOOD"], ["SAVED THIS MONTH", "$310"]].map(([l, v]) => (
      <div key={l} className="flex items-center justify-between rounded-lg bg-white/5 px-2.5 py-2">
        <span className="font-mono text-[6px] tracking-widest text-zinc-500">{l}</span>
        <span className="font-display text-[10px] font-semibold text-white">{v}</span>
      </div>
    ))}
    <TabBar active={2} count={3} />
  </div>
);

/* ---------- DRIFT ---------- */

const DriftScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">DRIFT / TRIPS</div>
    <div className="relative h-20 overflow-hidden rounded-xl bg-white/5">
      <div className="absolute inset-0 opacity-60" style={{ background: "radial-gradient(circle at 30% 40%, rgba(59,130,246,0.35), transparent 60%)" }} />
      <svg className="absolute inset-0 h-full w-full opacity-40" viewBox="0 0 100 60" preserveAspectRatio="none">
        <path d="M0 45 C 20 30, 40 50, 60 25 S 90 20, 100 30" fill="none" stroke="#3b82f6" strokeWidth="1" strokeDasharray="3 3" />
      </svg>
      <div className="absolute left-[58%] top-[38%] h-2 w-2 rounded-full bg-accent shadow-[0_0_10px_rgba(59,130,246,0.8)]" />
    </div>
    <div className="rounded-lg bg-white/5 p-2">
      <div className="font-display text-[10px] font-semibold text-white">Lisbon, PT</div>
      <div className="font-mono text-[5px] tracking-widest text-zinc-500">12 PHOTOS — 3 ENTRIES</div>
    </div>
    <div className="grid grid-cols-3 gap-1.5">
      {[0, 1, 2].map((i) => (
        <div key={i} className="h-9 rounded-md bg-white/5 ring-1 ring-white/5" style={{ background: i === 1 ? "rgba(59,130,246,0.15)" : undefined }} />
      ))}
    </div>
    <TabBar active={1} count={3} />
  </div>
);

const DriftJournalScreen = () => (
  <div className="flex h-full flex-col gap-2.5 p-3 pt-8">
    <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">DRIFT / JOURNAL</div>
    {[["DAY 04", "Alfama at golden hour", true], ["DAY 03", "Tram 28, lost on purpose", false], ["DAY 02", "Pastel de nata index", false]].map(([d, t, hot]) => (
      <div key={d} className={`rounded-lg p-2.5 ring-1 ${hot ? "bg-accent-soft ring-accent/30" : "bg-white/5 ring-white/5"}`}>
        <div className="font-mono text-[6px] tracking-widest text-accent">{d}</div>
        <div className="mt-1 font-display text-[10px] font-medium text-white">{t}</div>
        <div className="mt-1.5 space-y-1">
          <Bar h="h-1" />
          <Bar h="h-1" w="w-2/3" />
        </div>
      </div>
    ))}
    <div className="mt-auto self-end">
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-accent font-display text-sm font-semibold text-white shadow-[0_0_16px_rgba(59,130,246,0.5)]">+</div>
    </div>
  </div>
);

const DriftPhotosScreen = () => (
  <div className="flex h-full flex-col gap-2 p-3 pt-8">
    <div className="flex items-center justify-between">
      <div className="font-mono text-[7px] tracking-[0.2em] text-zinc-500">DRIFT / GALLERY</div>
      <div className="font-mono text-[6px] text-zinc-500">128</div>
    </div>
    <div
      className="relative h-24 overflow-hidden rounded-xl ring-1 ring-white/10"
      style={{ background: "linear-gradient(160deg, rgba(59,130,246,0.35), #141417 70%)" }}
    >
      <div className="absolute inset-0 opacity-50" style={{ background: "radial-gradient(circle at 70% 20%, rgba(255,255,255,0.15), transparent 50%)" }} />
      <div className="absolute bottom-1.5 left-2 font-mono text-[5px] tracking-widest text-white/80">LISBON — 38.71°N</div>
    </div>
    <div className="grid grid-cols-3 gap-1.5">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="h-10 rounded-md ring-1 ring-white/5"
          style={{ background: i % 3 === 1 ? "rgba(59,130,246,0.14)" : "rgba(255,255,255,0.05)" }}
        />
      ))}
    </div>
    <TabBar active={2} count={3} />
  </div>
);

const screens = {
  pulse: PulseScreen,
  pulseRing: PulseScreen,
  pulseTrends: PulseTrendsScreen,
  pulseWorkout: PulseWorkoutScreen,
  ledger: LedgerScreen,
  ledgerBalance: LedgerScreen,
  ledgerBudgets: LedgerBudgetsScreen,
  ledgerStats: LedgerStatsScreen,
  drift: DriftScreen,
  driftMap: DriftScreen,
  driftJournal: DriftJournalScreen,
  driftPhotos: DriftPhotosScreen,
};

const StatusBar = () => (
  <div className="absolute left-0 right-0 top-0 z-20 flex items-center justify-between px-5 pt-3">
    <span className="font-display text-[8px] font-semibold tracking-wide text-white">9:41</span>
    <div className="flex items-center gap-1.5">
      <div className="flex h-[7px] items-end gap-[1.5px]">
        {[3, 5, 7, 7].map((h, i) => (
          <div key={i} className="w-[2px] rounded-[0.5px] bg-white" style={{ height: `${h}px`, opacity: i < 3 ? 1 : 0.35 }} />
        ))}
      </div>
      <svg className="h-[7px] w-[9px] text-white" viewBox="0 0 12 9" fill="currentColor">
        <path d="M6 8.2 3.9 6a3 3 0 0 1 4.2 0L6 8.2ZM1.7 3.8a6.1 6.1 0 0 1 8.6 0l-1.3 1.3a4.3 4.3 0 0 0-6 0L1.7 3.8Z" />
      </svg>
      <div className="flex h-[8px] w-[15px] items-center rounded-[2.5px] border border-white/60 p-[1.5px]">
        <div className="h-full w-[72%] rounded-[1px] bg-white" />
      </div>
    </div>
  </div>
);

export default function PhoneMockup({ variant, image, imagePosition = "center", widthClass = "w-44 sm:w-52", glow = true, className = "" }) {
  const Screen = variant ? screens[variant] : null;
  return (
    <div className={`relative ${className}`} data-testid={`phone-mockup-${variant || "screenshot"}`}>
      {glow && <div className="absolute -inset-8 rounded-full bg-accent/10 blur-3xl" aria-hidden="true" />}
      <div className={`relative aspect-[71.9/150] ${widthClass}`}>
        {/* side buttons */}
        <div className="absolute -left-[2px] top-[15.5%] h-[4.5%] w-[3px] rounded-l-sm bg-gradient-to-b from-zinc-500 via-zinc-300 to-zinc-500" />
        <div className="absolute -left-[2px] top-[23%] h-[7.5%] w-[3px] rounded-l-sm bg-gradient-to-b from-zinc-500 via-zinc-300 to-zinc-500" />
        <div className="absolute -left-[2px] top-[32%] h-[7.5%] w-[3px] rounded-l-sm bg-gradient-to-b from-zinc-500 via-zinc-300 to-zinc-500" />
        <div className="absolute -right-[2px] top-[22%] h-[11%] w-[3px] rounded-r-sm bg-gradient-to-b from-zinc-500 via-zinc-300 to-zinc-500" />
        <div className="absolute -right-[2px] top-[63%] h-[9%] w-[3px] rounded-r-sm bg-gradient-to-b from-zinc-500 via-zinc-300 to-zinc-500" />
        {/* aluminum frame — proportions follow the 71.9 × 150 mm iPhone 17 Pro body */}
        <div
          className="relative h-full w-full bg-gradient-to-br from-zinc-300 via-zinc-600 to-zinc-500 p-[1.15%] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.9),0_0_40px_rgba(59,130,246,0.08)]"
          style={{ borderRadius: "16.7% / 8%" }}
        >
          {/* antenna bands */}
          <div className="absolute left-[18%] top-0 h-[2.5px] w-[7%] bg-zinc-800/80" />
          <div className="absolute bottom-0 right-[18%] h-[2.5px] w-[7%] bg-zinc-800/80" />
          <div
            className="h-full w-full bg-[#0a0a0c] p-[2.6%] ring-1 ring-black"
            style={{ borderRadius: "15.9% / 7.6%" }}
          >
            <div
              className="relative h-full w-full overflow-hidden bg-ink"
              style={{ borderRadius: "14.8% / 7%" }}
            >
              {!image && <StatusBar />}
              {/* dynamic island */}
              <div className="absolute left-1/2 top-[1.4%] z-30 flex h-[3.1%] w-[31%] -translate-x-1/2 items-center justify-end rounded-full bg-black px-1.5 shadow-[0_0_0_1px_rgba(255,255,255,0.04)]">
                <div className="relative flex h-[7px] w-[7px] items-center justify-center rounded-full bg-[#07101d] ring-1 ring-[#26364f] shadow-[inset_0_0_3px_rgba(59,130,246,0.55)]">
                  <div className="h-[3px] w-[3px] rounded-full bg-[#24558b] shadow-[0_0_3px_rgba(59,130,246,0.8)]" />
                  <div className="absolute left-[1px] top-[1px] h-[1.5px] w-[1.5px] rounded-full bg-white/70" />
                </div>
              </div>
              {image ? (
                <img
                  src={image}
                  alt="App screen"
                  className="h-full w-full object-cover"
                  style={{ objectPosition: imagePosition }}
                />
              ) : (
                Screen && <Screen />
              )}
              {!image && (
                <>
                  {/* glass reflection */}
                  <div
                    className="pointer-events-none absolute inset-0 z-40"
                    style={{ background: "linear-gradient(118deg, rgba(255,255,255,0.09) 0%, rgba(255,255,255,0.02) 18%, transparent 32%)" }}
                  />
                  <div
                    className="pointer-events-none absolute inset-0 z-40"
                    style={{ boxShadow: "inset 0 0 24px rgba(0,0,0,0.55)" }}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
